module.exports = __webpack_public_path__ + "static/aboutus-1-min-b49ddc24160342046bdfc214bfcbbb0d.webp";